export default {
  nav: {
    home: "Accueil",
    categories: "Catégories",
    guides: "Guides",
    buyingGuide: "Guide d'achat",
    faq: "FAQ",
  },
  hero: {
    badge: "Ressource indépendante AllChinaBuy",
    title: "AllChinaBuy Spreadsheet 2026",
    subtitle: "Découvrez des trouvailles AllChinaBuy organisées, des catégories de produits, des références QC, des guides d'expédition et des ressources pratiques pour acheter plus malin.",
    ctaSpreadsheet: "allchinabuy spreadsheet",
    ctaBuy: "Acheter maintenant",
    ctaGuide: "Lire le guide débutant",
  },
  categories: {
    title: "Parcourir les catégories du spreadsheet",
    subtitle: "Accédez directement à votre catégorie de produits préférée sur le spreadsheet complet.",
    browse: "Parcourir",
    shoes: "Chaussures",
    hoodies: "Hoodies/Sweats",
    tshirts: "T-Shirts",
    jackets: "Vestes",
    pants: "Pantalons/Shorts",
    headwear: "Couvre-chefs",
    sets: "Ensembles",
    underwear: "Sous-vêtements/Caleçons",
    jersey: "Maillots",
    accessories: "Accessoires",
    bags: "Sacs",
    belts: "Ceintures",
    perfumes: "Parfums",
    other: "Autres articles",
  },
  why: {
    title: "Pourquoi utiliser le spreadsheet AllChinaBuy ?",
    subtitle: "Une façon simple et organisée de rechercher des produits avant d'acheter.",
    f1t: "Trouvailles organisées",
    f1d: "Des liens produits sélectionnés, groupés par catégorie, pour éviter des heures de défilement.",
    f2t: "Références QC",
    f2d: "Apprenez quoi vérifier sur les photos de contrôle qualité avant d'expédier.",
    f3t: "Clarté sur l'expédition",
    f3d: "Comprenez le poids, le poids volumétrique et comment réduire les frais d'expédition.",
    f4t: "Adapté aux débutants",
    f4d: "Des étapes claires pour aider les nouveaux acheteurs à commander en confiance.",
  },
  guides: {
    title: "Guides et articles AllChinaBuy",
    subtitle: "Des guides indépendants et originaux pour acheter plus malin.",
    readMore: "Lire l'article",
  },
  faq: {
    title: "Questions fréquentes",
    q1: "Qu'est-ce que le spreadsheet AllChinaBuy ?",
    a1: "C'est une collection communautaire de liens et de trouvailles sélectionnés, organisés par catégorie, pour aider les acheteurs à découvrir des articles et à consulter plus facilement les références QC et d'expédition.",
    q2: "Ce site est-il le site officiel d'AllChinaBuy ?",
    a2: "Non. C'est une ressource indépendante et informative, non affiliée à AllChinaBuy. Les prix, tarifs d'expédition et politiques peuvent changer, vérifiez toujours avant d'acheter.",
    q3: "Les boutons de catégorie mènent-ils au spreadsheet principal ?",
    a3: "Oui. Chaque bouton de catégorie renvoie vers la catégorie correspondante sur le site principal.",
    q4: "Ai-je besoin d'un compte pour naviguer ?",
    a4: "Non, aucun compte n'est nécessaire pour explorer les guides et les liens de catégories de ce site.",
    q5: "Puis-je me fier aux infos d'expédition et de coupons ?",
    a5: "Les informations de ce site sont données à titre indicatif. Confirmez toujours les prix, coupons et tarifs actuels sur le site officiel avant de commander.",
  },
  cta: {
    title: "Prêt à explorer le spreadsheet complet ?",
    subtitle: "Rendez-vous sur le site principal pour parcourir le spreadsheet de produits complet et toujours à jour.",
    button: "Ouvrir le AllChinaBuy Spreadsheet",
  },
  footer: {
    tagline: "Une ressource indépendante pour les acheteurs AllChinaBuy.",
    disclaimerTitle: "Avertissement",
    disclaimer: "Ceci est une ressource indépendante et informative, non affiliée à AllChinaBuy. Les prix, tarifs d'expédition, coupons, vendeurs et politiques peuvent changer. Vérifiez toujours les informations actuelles avant d'acheter. Tous les liens externes s'ouvrent dans un nouvel onglet.",
    rights: "© 2026 AllChinaBuy Spreadsheet. Tous droits réservés.",
  },
};